import { Button } from "primereact/button";

import { Dialog, Stepper } from "@/ds";
import TimesIcon from "@/assets/icons/wizard-times.svg?react";
import { BUTTONS, CANCELAR_DIALOG, NOVA_OBRA_TITLE } from "./nova-obra.constants";
import { ConfirmacaoDialog } from "./components/confirmacao-dialog";
import { CriarObraAcao } from "./components/criar-obra-acao";
import { WizardToast } from "./components/wizard-toast";
import { EtapaEquipe } from "./etapa-equipe";
import { EtapaDuracao } from "./etapa-duracao";
import { EtapaObra } from "./etapa-obra";
import { EtapaRevisao } from "./etapa-revisao";
import { EtapaTiposObra } from "./etapa-tipos-obra";
import styles from "./nova-obra-screen.module.scss";
import type { NovaObraScreenViewModel } from "./types-nova-obra";

export function NovaObraScreenView({
  etapas,
  state,
  voltar,
  cancelar,
  sair,
  obraCriada,
  concluir,
  proximaEtapa,
  primeiraEtapa,
  ultimaEtapa,
  confirmandoSaida,
  fecharConfirmacaoSaida,
  guardaEquipe,
  verificandoEquipe,
  acompanharVerificacaoEquipe,
}: NovaObraScreenViewModel) {
  return (
    <>
      <Dialog
        visible
        modal
        size="lg"
        showHeader={false}
        closeOnEscape={false}
        onHide={cancelar}
        className={styles.dialog}
        contentClassName={styles.dialogContent}
        data-testid="nova-obra-dialog"
      >
        <WizardToast>
          <header className={styles.header}>
            <h1 className={styles.headerTitle}>{NOVA_OBRA_TITLE}</h1>
            <button type="button" className={styles.close} aria-label="Fechar" onClick={cancelar}>
              <TimesIcon aria-hidden />
            </button>
          </header>

          <div className={styles.main}>
            <Stepper.Root aria-label="Etapas da Nova Obra">
              {etapas.map(({ numero, titulo, situacao, ariaLabel, testId, onSelect }) => (
                <Stepper.Step
                  key={numero}
                  state={situacao}
                  number={numero}
                  title={titulo}
                  ariaLabel={ariaLabel}
                  onSelect={onSelect}
                  className={styles.etapa}
                  testId={testId}
                />
              ))}
            </Stepper.Root>
            <div className={styles.scroll}>
              {state.etapaAtual === 1 && <EtapaObra />}
              {state.etapaAtual === 2 && <EtapaDuracao />}
              {state.etapaAtual === 3 && <EtapaTiposObra />}
              {state.etapaAtual === 4 && (
                <EtapaEquipe
                  guardaAvancar={guardaEquipe}
                  onVerificandoChange={acompanharVerificacaoEquipe}
                />
              )}
              {state.etapaAtual > 4 && <EtapaRevisao />}
            </div>
          </div>

          <footer className={styles.footer}>
            <Button
              type="button"
              label={primeiraEtapa ? BUTTONS.cancelar : BUTTONS.voltar}
              text
              className={styles.footerButton}
              onClick={primeiraEtapa ? cancelar : voltar}
            />
            <div className={styles.actions}>
              {/* Salvar Rascunho: sem HU de rascunho (Impasse 37/R3); permanece desabilitado. */}
              <Button
                type="button"
                label={BUTTONS.salvarRascunho}
                severity="secondary"
                disabled
                className={styles.footerButton}
              />
              {ultimaEtapa ? (
                <CriarObraAcao
                  className={styles.footerButton}
                  onCriada={obraCriada}
                  onConcluida={concluir}
                />
              ) : (
                <Button
                  type="button"
                  label={BUTTONS.proximaEtapa}
                  onClick={proximaEtapa}
                  loading={verificandoEquipe}
                  disabled={verificandoEquipe}
                  className={styles.footerButton}
                />
              )}
            </div>
          </footer>
        </WizardToast>
      </Dialog>

      <ConfirmacaoDialog
        visible={confirmandoSaida}
        header={CANCELAR_DIALOG.title}
        message={CANCELAR_DIALOG.text}
        acceptLabel={CANCELAR_DIALOG.confirm}
        rejectLabel={CANCELAR_DIALOG.cancel}
        accept={sair}
        onHide={fecharConfirmacaoSaida}
        testId="confirmar-cancelar"
      />
    </>
  );
}
